export enum ButtonLevel {
  Danger = 'danger',
  Primary = 'primary',
  Secondary = 'secondary',
  Ghost = 'ghost',
  'Text-Primary' = 'text-primary',
  'Text-Secondary' = 'text-secondary',
  'Text-Danger' = 'text-danger',
  Gradient = 'gradient',
}

export enum ButtonSize {
  Xl = 'xl',
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
  Xs = 'xs',
}
